"use client";
import React, { useEffect, useRef } from "react";
import { ThemeProvider, CssBaseline } from "@bpipartners/webui";
import { getTheme } from "@guberno/utils/theme";
import { SnackbarProvider } from "notistack";
import { FaroWeb, Faro } from "./Faro";
import { FaroErrorBoundary } from "@grafana/faro-react";
import { FallbackErrorComponent } from "@guberno/ui";
import { SmallCheckMark } from "./SmallCheckmark";
import { ErrorBoundary } from "react-error-boundary";
import { WebuiClientWrapper } from "./_useWcWebuiWrapper";

export const ClientProviders = ({
  children,
  isAnalticsEnabled,
  appName,
}: {
  children?: React.ReactNode;
  isAnalticsEnabled?: string;
  appName: string;
}) => {
  const faroRef = useRef<null | Faro>(null);

  useEffect(() => {
    if (!faroRef.current && typeof window !== "undefined" && isAnalticsEnabled === "true") {
      //@ts-ignore
      faroRef.current = FaroWeb();
    }
  }, [isAnalticsEnabled]);

  const shouldRenderErrorBoundry = () => {
    if (isAnalticsEnabled === "false") {
      return <ErrorBoundary FallbackComponent={FallbackErrorComponent}></ErrorBoundary>;
    } else {
      return (
        <FaroErrorBoundary
          fallback={(error, reset) => FallbackErrorComponent({ error, resetErrorBoundary: reset })}
        ></FaroErrorBoundary>
      );
    }
  };

  return (
    <ThemeProvider theme={getTheme(appName)}>
      <SnackbarProvider
        autoHideDuration={3000}
        maxSnack={3}
        Components={{
          smallCheckMark: SmallCheckMark,
        }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {shouldRenderErrorBoundry()}
        <CssBaseline />
        <WebuiClientWrapper>{children}</WebuiClientWrapper>
      </SnackbarProvider>
    </ThemeProvider>
  );
};
